import { useEffect, useState } from "react";
import httpClient from "../../../custom-hooks/httpClient";

function InitiateTransfer({
  handleInitiateTransfer,
  handleChangeTransferDetails,
  user,
  transferDetails,
}) {
  const [areFieldsSet, setAreFieldsSet] = useState(false);
  const [dataplans, setDataPlans] = useState([]);
  const [selectedOperator, setSelectedOperator] = useState("");
  const [selectedDataPlan, setSelectedDataPlan] = useState("");
  const [amount, setAmount] = useState("");

  const userToken = localStorage.getItem("tk");

  useEffect(() => {
    const { transaction_pin, ...fields } = transferDetails;
    Object.values(fields).includes("")
      ? setAreFieldsSet(false)
      : setAreFieldsSet(true);
  }, [transferDetails]);

  useEffect(() => {
    async function getDataPlans() {
      try {
        const response = await httpClient.get("/data/get-data-plans", {
          method: "GET",
          headers: {
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
            Authorization: `Bearer ${userToken}`,
          },
        });

        const jsonData = response.data;
        // console.log((jsonData));
        setDataPlans(jsonData.data);
      } catch (err) {
        console.error(err.message);
      }
    }
    getDataPlans();
  }, [userToken]);

  // Function to filter data plans based on the selected network operator.
  const filteredDataPlan = (network) => {
    return dataplans.filter((plan) => plan.OPERATOR === network);
  };

  const handleOperatorChange = (e) => {
    handleChangeTransferDetails(e);
    setSelectedOperator(e.target.value);
    setSelectedDataPlan("");
    setAmount("");
  };

  // After an operator has been selected, handle input changes for data plans and amount when a data plan is selected.
  const handleDataPlanChange = (e) => {
    const selectedPlan = e.target.value;
    // Update selected data plan and amount.
    setSelectedDataPlan(selectedPlan);
    const selectedPlanObj = dataplans.find(
      (plan) => plan.DATA_PLAN === selectedPlan,
    );
    setAmount(selectedPlanObj?.AMOUNT || "");
    // Update transfer details.
    handleChangeTransferDetails([
      { target: { name: "dataplan", value: JSON.stringify(selectedPlanObj) } },
      { target: { name: "amount", value: selectedPlanObj?.AMOUNT || "" } },
    ]);
  };

  return (
    <>
      <h2 className="mb-5 text-primary fw-bold">Initiate Data Purchase</h2>
      <div className="card shadow h-100 py-2">
        <div className="card-body">
          <h3 className="card-title text-muted">Purchase Data</h3>
          <form onSubmit={handleInitiateTransfer}>
            <div className="form-group mb-3">
              <label
                className="form-label text-secondary"
                htmlFor="walletAccountNumber"
              >
                From Wallet
              </label>
              <select
                className="form-control  form-check-label"
                name="wallet_account_number"
                id="walletAccountNumber"
                onChange={handleChangeTransferDetails}
              >
                <option value="">--Select Wallet--</option>
                {/* Exclude Savings wallet as it is not a transactable */}
                {user.wallets
                  .filter((wallet) => wallet.type !== "savings")
                  .map((wallet) => (
                    <option value={wallet.account_no} key={wallet.id}>
                      {wallet.name} (&#8358;
                      {Number(wallet.balance).toFixed(2).toLocaleString()})
                    </option>
                  ))}
              </select>
            </div>

            <div className="form-group mb-3">
              <label
                className="form-label text-secondary"
                htmlFor="phoneNumber"
              >
                Phone Number
              </label>

              <input
                name="phoneNumber"
                id="phoneNumber"
                type="tel"
                className="form-control"
                placeholder="Receiving Phone Number"
                title="Numbers only, e.g. 08023456789"
                maxLength="11"
                pattern="0[0-9]{10}"
                required
                onChange={handleChangeTransferDetails}
              />
            </div>

            <div className="form-group mb-3">
              <label className="form-label text-secondary" htmlFor="network">
                Network
              </label>
              <select
                className="form-control form-check-label"
                name="network"
                id="network"
                value={selectedOperator}
                onChange={handleOperatorChange}
              >
                <option value="">---Select Network---</option>
                <option value="9MOBILE">9MOBILE</option>
                <option value="GLO">GLO</option>
                <option value="MTN">MTN</option>
                <option value="AIRTEL">AIRTEL</option>
              </select>
            </div>

            {selectedOperator && (
              <div className="form-group mb-3 ">
                <label className="form-label text-secondary" htmlFor="data">
                  Data Plan
                </label>
                <select
                  className="form-control form-check-label"
                  name="dataplan"
                  id="data"
                  value={selectedDataPlan ? selectedDataPlan.DATAPLAN_DESC : ""}
                  onChange={handleDataPlanChange}
                >
                  <option value="">--Select Data Plan--</option>
                  {filteredDataPlan(selectedOperator).map((plan) => (
                    <option key={plan.DATA_PLAN} value={plan.DATA_PLAN}>
                      {plan.DATAPLAN_DESC}
                    </option>
                  ))}
                </select>
              </div>
            )}

            {selectedDataPlan && (
              <div className="form-group mb-5">
                <label
                  className="form-label text-secondary"
                  htmlFor="transferAmount"
                >
                  &#8358; Amount
                </label>
                <input
                  name="amount"
                  id="transferAmount"
                  value={amount}
                  className="form-control"
                  placeholder=""
                  readOnly
                />
              </div>
            )}

            <button
              type="submit"
              className="btn w-100 btn-primary"
              disabled={!areFieldsSet}
            >
              Proceed
            </button>
          </form>
        </div>
      </div>
    </>
  );
}

export default InitiateTransfer;
